import React from 'react';

const CustomDateModal = ({
    customStartDate,
    customEndDate,
    setCustomStartDate,
    setCustomEndDate,
    handleApplyCustomDate,
    t,
}) => (
    <div className="modal add-money-modal fade" id="period" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h2 className="modal-title">{t('selectPeriod')}</h2>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                        <label htmlFor="inputfromdate" className="form-label">
                            {t('fromDate')}
                        </label>
                        <input
                            type="date"
                            className="form-control"
                            id="inputfromdate"
                            value={customStartDate}
                            onChange={(e) => setCustomStartDate(e.target.value)}
                        />
                    </div>
                    <div className="form-group mt-3">
                        <label htmlFor="inputtodate" className="form-label">
                            {t('toDate')}
                        </label>
                        <input
                            type="date"
                            className="form-control"
                            id="inputtodate"
                            value={customEndDate}
                            onChange={(e) => setCustomEndDate(e.target.value)}
                        />
                    </div>
                    <button
                        className="btn theme-btn successfully w-100 mt-4"
                        onClick={handleApplyCustomDate}
                    >
                        {t('viewTransaction')}
                    </button>
                </div>
                <button type="button" className="btn close-btn" data-bs-dismiss="modal">
                    <i className="icon" data-feather="x"></i>
                </button>
            </div>
        </div>
    </div>
);

export default CustomDateModal;
